import { Component, computed, inject } from '@angular/core';

import { ChdButtonPresenter, ChdButtonVariant } from '@cp-produkte/cruise-hospitality-design';

import { ComponentsModule } from '../components.module';

/**
 * App-local renderer that draws `ChdButton` with the SpaManager `spa-button`
 * (native button). Plugged into the chd button slot via the backend provider,
 * e.g. `provideChdDxBackend({ button: ChdButtonSpaRenderer })`.
 *
 * Image icons (`iconSrc`) are mapped to `spa-button`'s local asset contract;
 * non-image icons use Material-symbol ligatures.
 */
@Component({
  selector: 'spa-chd-button-renderer',
  imports: [ComponentsModule],
  templateUrl: './chd-button-spa-renderer.component.html',
})
export class ChdButtonSpaRenderer {
  protected readonly presenter = inject(ChdButtonPresenter);

  protected readonly assetName = computed<string>(
    () => this.presenter.viewState().iconSrc.split('/').at(-1)?.split('.')[0] ?? '',
  );

  protected shapeFor(variant: ChdButtonVariant): 'primary' | 'secondary' | 'link' {
    if (variant === 'text') {
      return 'link';
    }
    return variant;
  }
}
